import { StyleSheet } from 'react-native';
import { Colors } from 'react-native-paper';
import { appColors } from '../../../assets/styles/global';
import { pixelDimensions } from '../../../config/utils';

const styles = StyleSheet.create({
  buttonArrowBack: {
    position: 'absolute',
    left: pixelDimensions(5),
    height: pixelDimensions(10),
    width: pixelDimensions(10),
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: pixelDimensions(100),
  },
  buttonStart: {
    width: pixelDimensions(80),
    alignSelf: 'center',
    justifyContent: 'center',
    height: pixelDimensions(12),
  },
  content: {
    flex: 1,
    alignItems: 'center',
  },
  header: {
    height: pixelDimensions(15),
    paddingVertical: pixelDimensions(5),
    justifyContent: 'center',
    backgroundColor: Colors.indigo700,
  },
  iconArrowBack: {
    fontSize: pixelDimensions(10),
    color: Colors.white,
  },
  iconHeart: {
    fontSize: pixelDimensions(40),
    color: appColors.primary,
  },
  iconStart: {
    fontSize: pixelDimensions(6),
    color: appColors.white,
  },
  input: {
    fontSize: pixelDimensions(4),
    backgroundColor: Colors.white,
    fontFamily: 'MMedium',
    paddingVertical: pixelDimensions(3),
    paddingLeft: pixelDimensions(12),
    marginBottom: pixelDimensions(2),
    borderColor: Colors.grey500,
    borderWidth: 1,
  },
  inputNoIcon: {
    paddingLeft: pixelDimensions(3),
  },
  inputIcon: {
    fontSize: pixelDimensions(5),
    position: 'absolute',
    color: Colors.grey700,
    top: pixelDimensions(3),
    left: pixelDimensions(3),
  },
  scroll: {
    paddingBottom: pixelDimensions(5),
    width: pixelDimensions(100),
  },
  textButtonGreen: {
    textAlign: 'center',
    color: Colors.white,
    fontSize: pixelDimensions(5),
  },
  textClassify: {
    fontSize: pixelDimensions(4),
    textAlign: 'center',
    color: Colors.indigo700,
    paddingVertical: pixelDimensions(3),
  },
  textMoreSpace: {
    marginVertical: pixelDimensions(5),
  },
  textPNFAM: {
    color: appColors.primary,
    textAlign: 'center',
    fontSize: pixelDimensions(6),
  },
  textNewPNFAM: {
    color: appColors.primary,
    textAlign: 'center',
    fontSize: pixelDimensions(4),
  },
  textDataSecretPNFAM: {
    color: appColors.primary,
    textAlign: 'center',
    fontSize: pixelDimensions(5),
  },
  textTitle: {
    fontSize: pixelDimensions(5),
    color: Colors.white,
    textAlign: 'center',
  },
  viewBase: {
    flex: 1,
    backgroundColor: Colors.grey300,
  },
  viewIconHeart: {
    alignSelf: 'center',
    height: pixelDimensions(50),
    width: pixelDimensions(50),
    alignItems: 'center',
    justifyContent: 'center',
  },
  viewBorderedIcon: {
    borderRadius: pixelDimensions(50),
    backgroundColor: Colors.white,
    borderColor: appColors.primary,
    borderWidth: pixelDimensions(3),
    marginVertical: pixelDimensions(10),
  },
  viewFields: {
    width: pixelDimensions(45),
  },
  viewL1Params: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-around',
    paddingVertical: pixelDimensions(2),
  },
  viewL2Params: {
    padding: pixelDimensions(5),
  },
  viewStart: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
});

export default styles;
